import { useEffect, useState } from "react";

export default function usePointData(province, isAdmin) {
  const [data, setData] = useState({
    pointData: null,
    pointData1: null,
    pointData2: null,
  });

  useEffect(() => {
    if (!province && !isAdmin) return;

    const load = async () => {
      try {
        if (isAdmin) {
          const [sbk, sam, station] = await Promise.all([
            import("../component/maps/geojsonSBK"),
            import("../component/maps/geojsonSAM"),
            import("../component/maps/geojsonSTATION"),
          ]);

          setData({
            pointData: sbk.pointData,
            pointData1: sam.pointData1,
            pointData2: station.pointData2,
          });
        } else {
          const [bimeh, sameteo, station] = await Promise.all([
            import(
              `../component/maps/points/bimeh_points_province_${province}_2025-04-29`
            ),
            import(
              `../component/maps/points/sameteo_points_province_${province}_2025-04-29`
            ),
            import(
              `../component/maps/points/station_points_province_${province}_2025-04-29`
            ),
          ]);

          setData({
            pointData: bimeh.pointData,
            pointData1: sameteo.pointData1,
            pointData2: station.pointData2,
          });
        }
      } catch (e) {
        console.error("GeoJSON load failed", e);
      }
    };

    load();
  }, [province, isAdmin]);

  return data;
}
